import React, { useEffect, useState } from "react";

const InstallPWAButton = ({ label = "حمل التطبيق" }) => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    const isStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true;
    setIsInstalled(isStandalone);

    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };

    const handleAppInstalled = () => {
      setDeferredPrompt(null);
      setIsInstalled(true);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    window.addEventListener("appinstalled", handleAppInstalled);

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt
      );
      window.removeEventListener("appinstalled", handleAppInstalled);
    };
  }, []);

  const handleInstallClick = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === "accepted") {
        setDeferredPrompt(null);
      }
      return;
    }

    const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);
    if (isIOS) {
      alert(
        "لتثبيت التطبيق: اضغط زر المشاركة في Safari ثم اختر «إضافة إلى الشاشة الرئيسية»."
      );
    } else {
      alert(
        "لتثبيت التطبيق: من قائمة المتصفح (⋮) اختر «تثبيت التطبيق» أو «إضافة إلى الشاشة الرئيسية»."
      );
    }
  };

  if (isInstalled) {
    return null;
  }

  return (
    <div>
      <div
        className="mt-4 mb-2 text-center"
        style={{ fontSize: "17px", cursor: "pointer" }}
        onClick={handleInstallClick}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => e.key === "Enter" && handleInstallClick()}>
        <img
          src={`${process.env.PUBLIC_URL}/a3maal.png`}
          alt=""
          style={{ width: "53px", borderRadius: "41%", objectFit: "contain" }}
        />
        <i className="fa-solid fa-download"></i> {label}
      </div>
    </div>
  );
};

export default InstallPWAButton;
